var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCountries(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "countries",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "rect8872",
    width: 30,
    height: 30,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g3689",
    transform: "translate(3.177 3.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3360",
    d: "M77.936,1.939a11.681,11.681,0,0,0-4.679.945,11.975,11.975,0,0,0-6.375,6.375,11.688,11.688,0,0,0-.946,4.68,11.682,11.682,0,0,0,.946,4.679,11.975,11.975,0,0,0,6.375,6.375,12.052,12.052,0,0,0,9.36,0,11.985,11.985,0,0,0,6.375-6.375,11.681,11.681,0,0,0,.945-4.679,12.071,12.071,0,0,0-.308-2.729A7.2,7.2,0,0,1,88.134,13.9c0,.014,0,.028,0,.042a10.79,10.79,0,0,1-.165,1.889,9.608,9.608,0,0,1-.51,1.815,10.7,10.7,0,0,1-.84,1.7,9.9,9.9,0,0,1-1.154,1.529,2.537,2.537,0,0,0-.9-1.32,2.433,2.433,0,0,0-1.53-.51h-1.29V16.253a7.2,7.2,0,0,1-4.352-2.313H72.836V11.3h2.49a1.406,1.406,0,0,0,.536-.1,7.2,7.2,0,0,1-.326-2.055,7.2,7.2,0,0,1,5.172-6.882A12.06,12.06,0,0,0,77.936,1.939Zm-9.929,9.629,6.15,6.15v1.321a2.609,2.609,0,0,0,.72,1.829,2.314,2.314,0,0,0,1.77.78v2.46a9.672,9.672,0,0,1-6.375-3.36,10.042,10.042,0,0,1-2.535-6.81,11.628,11.628,0,0,1,.06-1.186,8.433,8.433,0,0,1,.211-1.185Z",
    transform: "translate(-65.936 -1.939)",
    fill: "rgba(0,0,0,0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3491",
    d: "M89.422,14.594V4.513h5.085l.282,1.275h3.528v5.485h-3.8l-.282-1.26H90.311v4.581ZM93.869,7.893Zm1.408,2.49h2.15V6.678H94.032L93.751,5.4H90.311V9.124H95Z",
    transform: "translate(-75.184 -2.992)",
    fill: "rgba(0,0,0,0.6)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountries);
export default __webpack_public_path__ + "static/media/Countries.593fcce49fd74271fb4dda4fd134ded2.svg";
export { ForwardRef as ReactComponent };